// Kept in step with bizro-sapiens-frontend lib/phone.ts and lib/postcode.ts.
const PHONE = /^\+?[\d\s().-]+$/;
const INDIA_PIN = /^[1-9]\d{5}$/;
// 3 to 10 letters or digits, with at most one inner space or hyphen (SW1A 1AA, 94105-1234).
const POSTCODE = /^(?=.{3,10}$)[A-Za-z0-9]+(?:[ -][A-Za-z0-9]+)?$/;

// Countries that have no postal code system, so the field may be left blank.
const NO_POSTCODE = new Set([
  "united arab emirates", "uae", "qatar", "hong kong", "macao", "macau", "bahamas", "fiji",
  "angola", "aruba", "belize", "botswana", "cameroon", "dominica", "grenada", "gambia", "kiribati",
  "malawi", "rwanda", "seychelles", "suriname", "togo", "tonga", "tuvalu", "uganda", "vanuatu",
  "yemen", "zimbabwe", "burkina faso", "syria", "north korea", "saint kitts and nevis",
  "saint lucia", "solomon islands", "timor-leste", "tokelau", "cook islands", "niue",
]);

export const MOBILE_INVALID = "Enter a valid mobile number, like +91 98765 43210";

export const normalizeMobile = (value: string) => {
  const v = value.trim();
  return (v.startsWith("+") ? "+" : "") + v.replace(/\D/g, "");
};

export function isValidMobile(value: string): boolean {
  const v = value.trim();
  const normalized = normalizeMobile(v);
  const digits = normalized.replace("+", "");
  // The account column holds 15 characters, plus included.
  if (!PHONE.test(v) || digits.length < 7 || normalized.length > 15) return false;
  // +91 means an Indian mobile: 10 digits starting 6 to 9.
  return !v.startsWith("+91") || /^91[6-9]\d{9}$/.test(digits);
}

export function postcodeError(value: string | null | undefined, country?: string | null): string | null {
  const v = (value ?? "").trim();
  const c = (country ?? "").trim().toLowerCase();
  if (!v) return NO_POSTCODE.has(c) ? null : "Pin code is required";
  if (c === "india") return INDIA_PIN.test(v) ? null : "Enter a valid 6-digit PIN code";
  return POSTCODE.test(v) ? null : "Enter a valid postal code";
}

export const PASSWORD_EDGE_SPACE = "Password can't start or end with a space";

/** Space-only passwords fail too, since they start with a space. */
export const noEdgeSpaces = (value?: string) => !value || value.trim() === value;
